import { RootState } from '../../reducers';

export const hasDashboardExclamation = (state: RootState) => state.entities.dashboard.exclamation;
export const getWidgets = (state: RootState) => state.entities.dashboard.widgets;
